import React from 'react';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';

export default function ToggleSwitch(props) {
  const { checked, onChange, additionalClasses, ariaLabel, disabled = false } = props;

  return (
    <Switch
      checked={checked}
      onChange={onChange}
      className={additionalClasses}
      aria-label={ariaLabel}
      disabled={disabled}
    />
  );
}
